import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { Labor } from './labor';
import { LaborDialogComponent } from './labor-dialog/labor-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({ selector: 'kiene-labore', templateUrl: './labore.component.html', styleUrls: ['./labore.component.scss'] })
export class LaboreComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private notification: MessageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Labore';
        this.tableDescriptor.uniqueIdentifier = 'Labore';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'labor/';
        this.tableDescriptor.route = '/labor/labore/';
        this.tableDescriptor.nameOfIdField = 'labor_id';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;

        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Labor'));
        this.tableDescriptor.columns.push(new TableColumn('strasse', 'Straße'));
        this.tableDescriptor.columns.push(new TableColumn('plz', 'PLZ'));
        this.tableDescriptor.columns.push(new TableColumn('ort', 'Ort'));

        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'bearbeiten', 'edit', 1));
        this.tableDescriptor.options.push(new TableOption(this.openDeleteDialog.bind(this), 'löschen', 'delete', 1));

        this.tableDescriptor.permissionCreate = 1233;
        this.tableDescriptor.permissionView = 1231;

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openAddDialog.bind(this);
    }

    openDeleteDialog(labor: Labor) {
        let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: {
                title: labor.bezeichnung + ' löschen',
                text: 'Wollen Sie ' + labor.bezeichnung + ' wirklich löschen?',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.api.deleteEntity(this.apiBaseUrl + 'labor/delete.php', labor).subscribe(
                    () => {
                        this.notification.infoMessage('Labor erfolgreich gelöscht!');
                        this.api.reload();
                    },
                    error => {
                        this.notification.errorMessage('Labor konnte nicht gelöscht werden!', error);
                        this.api.reload();
                    },
                );
            }
        });
    }

    openAddDialog() {
        let dialogRef = this.dialog.open(LaborDialogComponent, { width: '50%', minWidth: '300px' });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const lab = <Labor>result;
                this.api.updateEntity(this.apiBaseUrl + 'labor/update.php', lab).subscribe(
                    () => {
                        this.notification.infoMessage('Labor erfolgreich gespeichert!');
                        this.api.reload();
                    },
                    error => {
                        this.notification.errorMessage('Labor konnte nicht gespeichert werden!', error);
                        this.api.reload();
                    },
                );
            }
        });
    }

    openEditDialog(labor: Labor) {
        let dialogRef = this.dialog.open(LaborDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: { labor: labor },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const lab = <Labor>result;
                this.api.updateEntity(this.apiBaseUrl + 'labor/update.php', lab).subscribe(
                    () => {
                        this.notification.infoMessage('Labor erfolgreich gespeichert!');
                        this.api.reload();
                    },
                    error => {
                        this.notification.errorMessage('Labor konnte nicht gespeichert werden!', error);
                        this.api.reload();
                    },
                );
            }
        });
    }
}
